<template>
  <!-- 品牌红包抽奖 -->
  <van-popup v-model="bigPrize" :close-on-click-overlay="false" @click-overlay="$emit('close')" :lock-scroll="false">
    <!-- 中奖 -->
    <div class="logo-prize">
      <!-- 现金 -->
      <div>
        <div class="red-box">
          <div class="logo-money">88元</div>
          <div class="logo-remark">现金红包</div>
          <img src="@this/assets/image-25.png" @click="$emit('close')" class="red-btn" />
        </div>
        <img :src="prizePicture" alt="" class="logo-coupon" />
      </div>
    </div>
    <div @click="$emit('close')" class="popup-close-blue"></div>
  </van-popup>
</template>

<script>
import { Popup } from 'vant';
export default {
  props: {
    bigPrize: {
      type: Boolean,
      default: false,
    },
    prizePicture: {
      type: String,
      default: '',
    },
  },
  components: {
    [Popup.name]: Popup,
  },
};
</script>
<style lang="scss" scoped>
.logo-prize {
  background: url(~@this/assets/image-30.png) no-repeat;
  background-size: 100% 100%;
  width: 577px;
  height: 661px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  .logo-coupon {
    width: 515px;
    height: 197px;
    position: absolute;
    left: 50%;
    top: 440px;
    transform: translate(-50%);
  }
}
.red-box {
  background: url(~@this/assets/image-29.png) no-repeat;
  background-size: 100% 100%;
  width: 515px;
  height: 270px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  left: 50%;
  top: 120px;
  transform: translate(-50%);
  .red-btn {
    position: absolute;
    left: 50%;
    top: 220px;
    transform: translate(-50%);
    width: 321px;
    height: 83px;
  }
}
.logo-money {
  margin-top: 40px;
  font-size: 95px;
  font-weight: 600;
  color: #ff4040;
}
.logo-remark {
  margin-top: 15px;
  color: #174f4c;
  font-weight: 800;
  font-size: 32px;
}
</style>
